import * as types from './mutation-types'
import {createFormData} from "@/mixins/Helpers";

function createMailFormData(data) {
    let formData = new FormData()

    data.subject && formData.append('subject', data.subject)
    formData.append('message', data.message)
    formData.append('folder', data.folder)
    formData.append('priority', data.priority)
    formData.append('request_receipt', data.request_receipt)
    formData.append('scheduled_at', data.scheduled_at)
    formData.append('is_draft', !!data?.is_draft)

    if(data.to) {
        data.to.forEach((x) => formData.append('to[]', x))
    }

    if(data.cc) {
        data.cc.forEach((x) => formData.append('cc[]', x))
    }

    if(data.bcc) {
        data.bcc.forEach((x) => formData.append('bcc[]', x))
    }

    if(data.attachments) {
        data.attachments.forEach((x) => formData.append('attachments[]', x))
    }

    if(data?.model_ids){
        data.model_ids.forEach((x) => formData.append('model_ids[]', x))
    }

    return formData
}

function createTransferMailFormData(data) {
    let formData = new FormData()

    formData.append('subject', data.subject)
    formData.append('message', data.message)
    formData.append('folder', data.folder)
    formData.append('priority', data.priority)
    formData.append('request_receipt', data.request_receipt)
    formData.append('scheduled_at', data.scheduled_at)
    formData.append('is_draft', !!data.is_draft)

    if(data.to) {
        data.to.forEach((x) => formData.append('to[]', x))
    }

    if(data.cc) {
        data.cc.forEach((x) => formData.append('cc[]', x))
    }

    if(data.bcc) {
        data.bcc.forEach((x) => formData.append('bcc[]', x))
    }

    if(data.newAttachments) {
        data.newAttachments.forEach((x) => formData.append('newAttachments[]', x))
    }

    if(data.attachments) {
        /*data.attachments.forEach((x) => formData.append('attachments[]', JSON.stringify(x)))*/
        data.attachments.forEach((x) => {
            formData.append('attachments['+ x.id +'][name]',  x.name)
            formData.append('attachments['+ x.id +'][url]',  x.url)
        })
    }

    if(data?.model_ids){
        data.model_ids.forEach((x) => formData.append('model_ids[]', x))
    }

    return formData
}

export const loadMails = ({ commit }, data) => {
    
    return new Promise((resolve, reject) => {
        window.axios.get('get/emails', {params: data}).then((response) => {
            commit(types.LOAD_MAILS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}



export const loadScheduleMails = ({ commit }, data) => {
    
    return new Promise((resolve, reject) => {
        window.axios.get('get/schedule/mail/collection', {params: data}).then((response) => {
            commit(types.LOAD_SCHEDULE_MAILS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadPriorities = ({ commit }) => {
    
    return new Promise((resolve, reject) => {
        window.axios.get('get/email/priorities').then((response) => {
            commit(types.LOAD_PRIORITIES, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadUsersAndContacts = ({ commit }) => {
    
    return new Promise((resolve, reject) => {
        window.axios.get('get/user/contact/email').then((response) => {
            commit(types.LOAD_USER_CONTACTS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getMail = ({ commit }, data) => {
    
    return new Promise((resolve, reject) => {
        window.axios.get('get/folder/email', {params: data}).then((response) => {
            commit(types.SET_CURRENT_MAIL, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getScheduleMail = ({ commit }, id) => {
    
    return new Promise((resolve, reject) => {
        window.axios.get('get/schedule/' + id + '/mail').then((response) => {
            commit(types.SET_CURRENT_MAIL, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const restoreMail = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('restore/trash/email', {params: data}).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const replyMail = ({ commit }, data) => {
    let formData = createMailFormData(data)

    return new Promise((resolve, reject) => {
        window.axios.post('emails/reply/' + data.email_id, formData).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const transferMail = ({ commit }, data) => {
    let formSubmit = createTransferMailFormData(data)
    return new Promise((resolve, reject) => {
        window.axios.post('transfer/email/' + data.email_id, formSubmit).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const createMail = ({commit}, data) => {
    let formData = createMailFormData(data)

    return new Promise((resolve, reject) => {
        window.axios.post('send-email', formData).then((response) => {
            resolve(response)
        }).catch((err) => {
            if (!data.is_draft) reject(err)
        })
    })
}

export const updateMail = ({commit}, data) => {
    let formData = createMailFormData(data)

    return new Promise((resolve, reject) => {
        window.axios.post('update/scheduled-emails/' + data.email_id, formData).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const markAsRead = ({commit}, data) => {

    return new Promise((resolve, reject) => {
        window.axios.post('mark/asRead/email', data).then((response) => {
            commit(types.MAKE_MAILS_AS_READ, data.email_ids)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const markAsUnread = ({commit}, data) => {

    return new Promise((resolve, reject) => {
        window.axios.post('mark/asUnread/email', data).then((response) => {
            commit(types.MAKE_MAILS_AS_UN_READ, data.email_ids)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const markAsImportant = ({commit}, data) => {

    return new Promise((resolve, reject) => {
        window.axios.post('mark/important/email', data).then((response) => {
            commit(types.MAKE_MAILS_AS_IMPORTANT, data.email_ids)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const markAsNotImportant = ({commit}, data) => {

    return new Promise((resolve, reject) => {
        window.axios.post('mark/not/important/email', data).then((response) => {
            commit(types.MAKE_MAILS_AS_NOT_IMPORTANT, data.email_ids)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const changeMailFolder = ({commit}, data) => {

    return new Promise((resolve, reject) => {
        window.axios.post('move/email', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteMail = ({commit}, data) => {

    return new Promise((resolve, reject) => {
        window.axios.delete('delete/email', {params: data}).then((response) => {
            commit(types.DESTROY_MAIL, data.email_ids)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteTrashMail = ({commit}, data) => {

    return new Promise((resolve, reject) => {
        window.axios.delete('delete/trash/email', {params: data}).then((response) => {
            commit(types.DESTROY_MAIL, data.email_ids)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteScheduleMail = ({commit}, data) => {

    return new Promise((resolve, reject) => {
        window.axios.post('delete/scheduled-emails', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getUserConfig = ({ commit }) => {
    
    return new Promise((resolve, reject) => {
        window.axios.get('get/user/imap/configs').then((response) => {
            if(response.data.data) {
               commit(types.SET_CONFIG_IMAP, response.data.data)
            }
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const setUserConfig = ({ commit }, data) => {
    
    return new Promise((resolve, reject) => {
        window.axios.post('set/user/imap/configs', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getImapConfig = ({ commit }) => {
    
    return new Promise((resolve, reject) => {
        window.axios.get('get/imap-config/collection').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const setImapConfig = ({ commit }, data) => {
    
    return new Promise((resolve, reject) => {
        window.axios.post('store/imap-config', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadSignatures = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/signature').then((response) => {
            commit(types.LOAD_SIGNATURES, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadActiveSignatures = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/actif/signature').then((response) => {
            commit(types.LOAD_ACTIVE_SIGNATURE, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const storeSignature = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/signature', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateSignature = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('update/signature/' + data.id, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const selectSignature = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('select/signature/' + id, {signature_id: id}).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteSignature = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('delete/signature/' + id).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const downloadAllFile = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`download/attachement`, data , {
            responseType: 'blob'
        }).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const logoutMail = ({commit}) => {
    return new Promise((resolve, reject) => {
        window.axios.post('logout/user/imap/configs').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadUnseenMailCount = ({commit}) => {
    return new Promise((resolve, reject) => {
      /*  window.axios.get("get/unseen/mail/count").then((response) => {
            commit(types.SET_UNSEEN_MAIL_COUNT, response.data.data)
            resolve(response.data)
        }).catch((err) => {
            reject(err)
        })*/
    })
}

export const updateDraftMail = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post("send/draft/mail/with/change", data).then((response) => {
            resolve(response.data)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadHistoryMails = ({ commit }, data) => {

    return new Promise((resolve, reject) => {
        window.axios.get('get/mail/history', {params: data}).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getHistoryMail = ({ commit }, data) => {

    return new Promise((resolve, reject) => {
        window.axios.get('get/folder/email', {params: data}).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const tagMail = ({ commit }, data) => {

    return new Promise((resolve, reject) => {
        window.axios.post('tag/mail', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}